export default "__VITE_ASSET__BzTWOeHF__";